export default "__VITE_ASSET__CV6zc0vR__"